import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { defaultMST4040_R01Filter, useMST4040_R01Store } from "./Store_MST4040_R01";

export const SearchSection_MST4040_R01 = () => {
	const { MST4040_R01Filter, setMST4040_R01Filter } = useMST4040_R01Store();
	const { moldClassList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'moldCd',
			category: '금형코드',
			focusId: 'moldCd_search',
			responseMapping: {
				moldCd: 'moldCd',
				moldNm: 'moldNm',
			},
			extraFilter: () => ({
				moldClass: MST4040_R01Filter.moldClass || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: MST4040_R01Filter,
		setEditData: setMST4040_R01Filter,
		defaultData: defaultMST4040_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'MST4040_R01_search',
	});

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="금형구분"
				value={MST4040_R01Filter.moldClass}
				onChangeItem={(item) => setMST4040_R01Filter({ moldClass: item?.minorCd || '' })}
				optionList={moldClassList}
			/>
			<SearchCodeModalForm
				label="금형코드"
				value={MST4040_R01Filter.moldCd}
				valueLabel={MST4040_R01Filter.moldNm}
				handleFoucsId="moldCd_search"
				onChange={getFieldHandlers('moldCd').onChange}
				onDoubleClick={getFieldHandlers('moldCd').onDoubleClick}
				onKeyDown={getFieldHandlers('moldCd').onEnterKeyDown}
			/>
		</SearchSectionForm>
	);
};
